module.exports = __webpack_public_path__ + "img/phone2.5b1e7d5d.webp";